import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
    //获取原型对象上的push函数
const originalPush = Router.prototype.push
    //修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
let router = new Router({
    routes:[
       {path:'/',component:() =>
                import ('../components/index.vue')},//全不匹配的情况下，返回到主页，路由按顺序从上到下，依次匹配。最后一个*能匹配全部，
       
    ]
});

router.beforeEach((to, from, next) => {


    next()
})

export default router